import React, { useRef } from 'react';
import { useScrollPosition } from '../../hooks';

/**
 * Componente ScaleOnScroll
 * Cambia el tamaño del elemento basado en la posición del scroll
 * 
 * @param {React.ReactNode} children - Contenido a escalar
 * @param {number} minScale - Escala mínima
 * @param {number} maxScale - Escala máxima
 */
export const ScaleOnScroll = ({ children, minScale = 0.8, maxScale = 1.2 }) => {
  // Obtiene la posición vertical del scroll usando un hook personalizado
  const { scrollY } = useScrollPosition();

  // Referencia al elemento DOM para posibles usos futuros
  const elementRef = useRef(null);
  
  // Calcula la escala del elemento según la posición del scroll
  // La escala varía linealmente entre minScale y maxScale cuando scrollY va de 0 a 1000
  // Math.min asegura que el valor máximo de scale no exceda maxScale
  const scale = minScale + (maxScale - minScale) * Math.min(scrollY / 1000, 1);
  
  return (
    <div
      ref={elementRef} // Asigna la referencia al div
      style={{
        // Aplica la transformación de escala calculada
        transform: `scale(${scale})`,
        // Agrega una transición suave al cambio de escala
        transition: 'transform 0.1s ease-out',
      }}
    >
      {children} {/* Renderiza el contenido pasado como hijo */}
    </div>
  );
};